export default __webpack_public_path__ + "static/media/crypto.4e4bca8b.png";